import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sports-cultural-committee',
  templateUrl: './sports-cultural-committee.component.html',
  styleUrls: ['./sports-cultural-committee.component.scss']
})
export class SportsCulturalCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
